import React from "react";
import { Edit as RaEdit, useNotify } from "react-admin";
import { useFormStyles } from "../components/forms/useStyles";
import Title from "../components/Title";
import Form from "./Form";

const Edit = (props) => {
	const classes = useFormStyles();
	const notify = useNotify();
	const onSuccess = (data) => {
		notify("ra.notification.updated", "info", { smart_count: 1 });
	};
	return (
		<RaEdit
			{...props}
			classes={classes}
			title={<Title source="name" />}
			mutationMode="pessimistic"
			onSuccess={onSuccess}
		>
			<Form />
		</RaEdit>
	);
};
export default Edit;
